import React, { useMemo } from "react"
import { getPEStepperOptions } from "../../utils/packagingExecutionUtils"
import { useSelector } from "react-redux"

import { getPackagingExecutionDateSelector, getPackagingExecutionSelector, getPackagingExecutionsSelector, getPackagingExecutionSiteSelector } from "../../reducers/Packaging/packagingExecution"
import { PE_STATUSES } from "../../utils/packagingExecutions"
import { buildGazTests, TESTGAZ_STATUS } from "../../utils/testGaz"
import PackagingExecutionToValidate from "./packagingExecutionToValidate/PackagingExecutionToValidate"
import PackagingExecutionTodo from "./packagingExecutionTodo/PackagingExecutionTodo"
import PackagingExecutionPackagingsCounting from "./packagingExecutionPackagingsCounting/PackagingExecutionPackagingsCounting"
import PackagingExecutionWasteToWeight from "./packagingExecutionWasteToWeight/PackagingExecutionWasteToWeight"
import PackagingExecutionDone from "./packagingExecutionDone/PackagingExecutionDone"

const PackagingExecution = () => {
	const selectedSite = useSelector(getPackagingExecutionSiteSelector)
	const selectedDate = useSelector(getPackagingExecutionDateSelector)
	const packagingExecution = useSelector(getPackagingExecutionSelector)
	const packagingExecutions = useSelector(getPackagingExecutionsSelector)
	
	if (!packagingExecution) return null

  const allStepperOptions = useMemo(() => getPEStepperOptions(packagingExecution?.packagings || []), [packagingExecution])
  const gazTests = useMemo(() => buildGazTests(packagingExecution, allStepperOptions), [packagingExecution, allStepperOptions])

	// Check if there are any sections with subStatus "INSUFFICIENT_WEIGHT"
	const hasSubStatus = packagingExecution.sections?.some(section => section.subStatus === "INSUFFICIENT_WEIGHT")

	if ([PE_STATUSES.toValidate, PE_STATUSES.locked].includes(packagingExecution.status)) {
		return <PackagingExecutionToValidate
			packagingExecution={packagingExecution}
			selectedSite={selectedSite}
			selectedDate={selectedDate}
			hasSubStatus={hasSubStatus}
		/>
	}

	if ([PE_STATUSES.todo, PE_STATUSES.inProgress].includes(packagingExecution.status)) {
		return <PackagingExecutionTodo 
			packagingExecution={packagingExecution}
			selectedSite={selectedSite}
			selectedDate={selectedDate}
			hasSubStatus={hasSubStatus}
			gazTests={gazTests}
			/>
	}

	if ([PE_STATUSES.packagingsCounting].includes(packagingExecution.status)) {
		return <PackagingExecutionPackagingsCounting
			packagingExecution={packagingExecution}
			selectedSite={selectedSite}
			selectedDate={selectedDate}
			hasSubStatus={hasSubStatus}
			/>
	}

	if (PE_STATUSES.waste === packagingExecution.status) {
		return <PackagingExecutionWasteToWeight
			packagingExecution={packagingExecution}
			selectedSite={selectedSite}
			selectedDate={selectedDate}
			hasSubStatus={hasSubStatus}
		/>
	}
	if (PE_STATUSES.done === packagingExecution.status) {
		return <PackagingExecutionDone
			packagingExecution={packagingExecution}
			packagingExecutions={packagingExecutions}
			selectedSite={selectedSite}
			selectedDate={selectedDate}
			hasSubStatus={hasSubStatus}
			gazTests={(gazTests || []).filter(test => test.status !== TESTGAZ_STATUS.TODO)}
		/>
	}

	return null
}

export default PackagingExecution